import axios from "axios";
import Constants from "../../../components.constants.js"

export default {
    async getAllFilesFromServer(context, payload = {}) {

        try {
            let resp = await axios.get(Constants.filesUrl, payload);
            if (resp.status == 200) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getAllFilesFromServer][Store][Error occured while getting fileslist--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    if (typeof(error.response.data) == "object") {
                        error.response.data.statusCode = error.response.status
                    } else {
                        error.response.data = { files: error.response.data, statusCode: error.response.status }
                    }
                    return error.response.data
                }
            }
            return {}
        }
    },

    async getAutoCompletedFoldersFromServer(context, payload = {}) {
        try {
            let resp = await axios.get(Constants.foldersUrl, payload);
            if (resp.status == 200) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getAutoCompletedFoldersFromServer][Store][Error occured while getting folderslist--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    if (typeof(error.response.data) == "object") {
                        error.response.data.statusCode = error.response.status
                    } else {
                        error.response.data = { files: error.response.data, statusCode: error.response.status }
                    }
                    return error.response.data
                }
            }
            return {}
        }
    },

    async getFileInfoFromServer(context, payload = {}) {
        //payload : {params:{fileId:"3422344231"}}

        try {
            let fileId = payload.params.fileId
            delete payload.params.fileId
            let resp = await axios.get(`${Constants.filesUrl}/${fileId}`, payload);
            if (resp.status == 200) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getFileInfoFromServer][Store][Error occured while getting file info--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },
    async getProxyOfFile(context, payload = {}) {

        try {
            let resp = await axios.get(`${Constants.filesUrl}` + "/default/proxy-info/" + payload.fileUid, payload);
            if (resp.status == 200) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getProxyOfFile][Store][Error occured while getting fileslist--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    if (typeof(error.response.data) == "object") {
                        error.response.data.statusCode = error.response.status
                    } else {
                        error.response.data = { files: error.response.data, statusCode: error.response.status }
                    }
                    return error.response.data
                }
            }
            return {}
        }
    },
    async updateFileInfo(context, payload = {}) {
        //payload : {params:{fileId:"3422344231"}}

        try {
            let resp = await axios.put(`${Constants.filesUrl}/${payload.params.fileId}`, payload);
            if (resp.status == 200) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[updateFileInfo][Store][Error occured while getting file info--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else if (error.response.status == 405) {
                    return { statusCode: error.response.status, message: "failed to update file info" }
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async getFolderStructureFromFileUID(context, payload = {}) {
        //payload : {params:{fileId:"3422344231"}}

        try {
            let fileId = payload.params.fileId
            delete payload.params.fileId
            let resp = await axios.get(`${Constants.filesUrl}/${fileId}/folder-structure`, payload);
            if (resp.status == 200) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getFolderStructureFromFileUID][Store][Error occured while getting file info--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else if (error.response.status == 405) {
                    return { statusCode: error.response.status, message: "failed to update file info" }
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async getStoryboardList(context, payload = {}) {

        try {
            let url = `${payload.url}`;
            // console.log("UUUUUUUUUUUUUUUUUUUU",window.location.host, url.startsWith(`https://${window.location.host}`))
            if (!url.startsWith(`https://${window.location.host}`)) {
                url = `${window.location.origin}/${url.replace("https://","").split("/").slice(1,url.replace("https://","").split("/").length).join("/")}`
            }
            // console.log("111111111111111111111111111", url)
            let resp = await axios.get(url);
            // console.log("@2222222222222222222222222", resp);
            if (resp.status == 200) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getProxyOfFile][Store][Error occured while getting fileslist--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    if (typeof(error.response.data) == "object") {
                        error.response.data.statusCode = error.response.status
                    } else {
                        error.response.data = { files: error.response.data, statusCode: error.response.status }
                    }
                    return error.response.data
                }
            }
            return []
        }
    },
    
    async getSearchKeywordAutoComplitionFromServer(context, payload = {}) {
        try {
            let resp = await axios.get(Constants.searchKeyworAutoCOmpleteUrl, payload);
            if (resp.status == 200) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getSearchKeywordAutoComplitionFromServer][Store][Error occured while getting fileslist--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    if (typeof(error.response.data) == "object") {
                        error.response.data.statusCode = error.response.status
                    } else {
                        error.response.data = { files: error.response.data, statusCode: error.response.status }
                    }
                    return error.response.data
                }
            }
            return {}
        }
    },
};